import { createSelector } from 'reselect'

import { initialState, initialToastState } from '../reducers/toasterReducer'

// select state from store
export const stateSelector = (state) => state.toaster || initialState
const idPropSelector = (_, props) => props.id

export const toasterSelector = createSelector(stateSelector, (state) => state.allIds.filter((id) => !state.byId[id].shown))

export const toastSelector = createSelector([stateSelector, idPropSelector], (state, id) => state.byId[id] || initialToastState)

export const toastTitleSelector = createSelector(toastSelector, (toast) => toast.title)

export const toastMessageSelector = createSelector(toastSelector, (toast) => toast.message)

export const toastVariantSelector = createSelector(toastSelector, (toast) => toast.variant)

export const toastTimeSelector = createSelector(toastSelector, (toast) => toast.time)
